import { render, staticRenderFns } from "./RecordResource.vue?vue&type=template&id=56ee5c47&"
import script from "./RecordResource.vue?vue&type=script&lang=js&"
export * from "./RecordResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports